import { createReducer } from 'redux-create-reducer'
import type { BusinessId, ContactId, RecipientListId } from 'types/list'
import type { UserId } from 'types/user'
import {
  CONTACTS_IMPORT_SUCCESS,
  EMAIL_GROUP_CREATE_SUCCESS,
  EMAIL_GROUP_UPDATE_SUCCESS,
  LIST_BUSINESS_FORM_DONE,
  LIST_FORM_CLOSE,
  LIST_FORM_DELETE,
  LIST_FORM_INCLUDE_BUSINESS,
  LIST_FORM_MODIFY_LISTS,
  LIST_FORM_SAVE,
  LIST_FORM_SAVE_ERROR,
  LIST_FORM_SAVE_SUCCESS,
  LIST_FORM_START_MANAGING_LISTS,
} from '@disco/constants/ActionTypes'
export type CheckboxState =
  | 'all'
  | 'none'
  | 'some-unchanged'
  | 'some-all'
  | 'some-none'
type ListsCheckboxState = Record<RecipientListId, CheckboxState>
export type BusinessesCheckboxState = Record<
  ContactId,
  Record<BusinessId, CheckboxState>
>
type ListModalSteps =
  | 'LIST_MODAL_0_NONE'
  | 'LIST_MODAL_3_BUSINESSES'
  | 'LIST_MODAL_4_MANAGE_LISTS'
export type State = {
  step: ListModalSteps
  keyStep: ListModalSteps
  userIds: Array<UserId> | null | undefined
  listsToChange: ListsCheckboxState
  recipients: Array<ContactId>
  recipientBusinesses: BusinessesCheckboxState
  saving: boolean
  error: Error | null | undefined
  lastImportContactIds: Array<ContactId>
  mode: ('MULTIPLE_LISTS' | 'SINGLE_LIST' | 'EXISTING_LIST') | null | undefined
  redirectTo: string | null | undefined
}
const initialState: State = {
  step: 'LIST_MODAL_0_NONE',
  keyStep: 'LIST_MODAL_0_NONE',
  userIds: null,
  listsToChange: {},
  recipients: [],
  recipientBusinesses: {},
  saving: false,
  error: null,
  mode: null,
  lastImportContactIds: [],
  redirectTo: null,
}

function changeBusiness(
  recipientBusinesses: BusinessesCheckboxState,
  contactId: ContactId,
  businessId: BusinessId,
  value: CheckboxState,
) {
  return {
    ...recipientBusinesses,
    [contactId]: { ...recipientBusinesses[contactId], [businessId]: value },
  }
}

function changeList(
  lists: ListsCheckboxState,
  list: RecipientListId,
  value: CheckboxState,
) {
  return { ...lists, [list]: value }
}

export const listFormReducer = createReducer<State, any>(initialState, {
  [LIST_FORM_START_MANAGING_LISTS](
    state,
    action: {
      invisible?: boolean
      selectedContacts: Array<ContactId>
      selectedList: RecipientListId | null | undefined
      multipleBusinesses: BusinessesCheckboxState
      mode: 'MULTIPLE_LISTS' | 'SINGLE_LIST' | 'EXISTING_LIST'
      redirectTo?: string
    },
  ) {
    let step: ListModalSteps = 'LIST_MODAL_4_MANAGE_LISTS'

    if (action.invisible) {
      step = 'LIST_MODAL_0_NONE'
    }

    return {
      ...state,
      step,
      keyStep: 'LIST_MODAL_4_MANAGE_LISTS',
      recipients: action.selectedContacts,
      recipientBusinesses: action.multipleBusinesses,
      mode: action.mode,
      error: null,
      listsToChange: action.selectedList
        ? {
            [action.selectedList]: 'all',
          }
        : {},
      redirectTo: action.redirectTo,
    }
  },

  [LIST_FORM_SAVE](state) {
    return { ...state, saving: true, error: null }
  },

  [LIST_FORM_SAVE_SUCCESS](state) {
    return { ...state, step: 'LIST_MODAL_0_NONE', saving: false, error: null }
  },

  [LIST_FORM_SAVE_ERROR](state, action) {
    return { ...state, saving: false, error: action.error }
  },

  [EMAIL_GROUP_CREATE_SUCCESS](state) {
    return { ...state, step: 'LIST_MODAL_0_NONE' }
  },

  [EMAIL_GROUP_UPDATE_SUCCESS](state) {
    return { ...state, step: 'LIST_MODAL_0_NONE' }
  },

  [LIST_FORM_DELETE](state) {
    return { ...state }
  },

  [LIST_FORM_CLOSE](state) {
    return { ...state, step: 'LIST_MODAL_0_NONE' }
  },

  [LIST_BUSINESS_FORM_DONE](state) {
    return { ...state, step: state.keyStep }
  },

  [LIST_FORM_INCLUDE_BUSINESS](state, action) {
    return {
      ...state,
      recipientBusinesses: changeBusiness(
        state.recipientBusinesses,
        action.contactId,
        action.businessId,
        action.value,
      ),
    }
  },

  [LIST_FORM_MODIFY_LISTS](
    state,
    action: {
      listId: RecipientListId
      selectedValue: CheckboxState
    },
  ) {
    return {
      ...state,
      listsToChange: changeList(
        state.listsToChange,
        action.listId,
        action.selectedValue,
      ),
    }
  },

  [CONTACTS_IMPORT_SUCCESS](state, action) {
    return { ...state, lastImportContactIds: action.contacts.map(c => c.id) }
  },
})
